import {
  getCarrierAssignedLoads,
  getDriverAssignedLoads,
  getInTransitLoads,
  getRecentDeliveredLoads,
  getStartTripShipmentStatusMessage,
  updateStopInfo,
} from "../../../selectors/Myload/selector";
import {
  getLoading,
  getUserMasterData,
  getNetworkStatus,
} from "../../../selectors/selector";
import { connect } from "react-redux";
import React from "react";
import { compose } from 'redux';
import { createStructuredSelector } from "reselect";
import { Execution } from "../../../web/components/execution/execution";
import { getStartTripShipment } from "../../../selectors/carrierAssign/selector";
import useInjectSaga from "../../../utils/injectSaga";
import saga from "../../../saga/ShipmentUpdate/saga";
import { updateStopInformationResponse, clearUpdateStopInformationResponse} from "../../../actions/myload/action";

const ExecutionDetailsContainer: React.FC<any> = (props: any) => {
  return <Execution {...props} loadDetails={props.shipmentToStartTrip} />;
};
const mapStateToProps = createStructuredSelector({
  loading: getLoading(),
  userDetails: getUserMasterData(),
  isNetworkAvailable: getNetworkStatus(),
  shipmentToStartTrip: getStartTripShipment(),
  driverLoads: getDriverAssignedLoads(),
  carrierLoads: getCarrierAssignedLoads(),
  inTransitLoads: getInTransitLoads(),
  recentDelivered: getRecentDeliveredLoads(),
  startTripShipmentStatusMessage: getStartTripShipmentStatusMessage(),
  updateStopInfo: updateStopInfo(),
});
export const mapDispatchToProps = (dispatch: Function) => ({ 
  updateStopInformationResponse: (data: any) => {
    dispatch(updateStopInformationResponse({ data }));
  },
  clearUpdateStopInformationResponse: () =>
  dispatch(clearUpdateStopInformationResponse()),
})
const withSaga = useInjectSaga({ key: 'shipment', saga });

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(
  withSaga,
  withConnect
)(ExecutionDetailsContainer);
